import type { RepPortalTabs } from "agent-portal";

import { TLPComponents } from "@repo/ui";
import {
	EntityIdProvider,
	OnboardingProvider,
	PendingChangesProvider,
	RepPortalInternal,
	RepProvider,
	SegmentProvider,
	UserProvider,
} from "agent-portal";
import { MemoryRouter } from "react-router-dom";

import { getInitialUrl } from "../helpers/agentPortal";

interface AgentPortalProps {
	repId: number | null;
	selectedTab?: RepPortalTabs;
	entityId?: number;
	segmentId?: number;
	editOnly?: boolean;
}

export function AgentPortal({ repId, selectedTab, entityId, segmentId, editOnly }: AgentPortalProps) {
	return (
		<MemoryRouter initialEntries={[getInitialUrl(repId, selectedTab, entityId)]} initialIndex={0}>
			<UserProvider>
				<PendingChangesProvider>
					<EntityIdProvider entityId={undefined}>
						<RepProvider item={{ repId: repId }}>
							<SegmentProvider initialSegmentId={segmentId}>
								<OnboardingProvider>
									<RepPortalInternal editOnly={editOnly} />
									<TLPComponents showToastContainer={false} />
								</OnboardingProvider>
							</SegmentProvider>
						</RepProvider>
					</EntityIdProvider>
				</PendingChangesProvider>
			</UserProvider>
		</MemoryRouter>
	);
}
